// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"386":"order-detail","486":"orders"}[chunkId] || chunkId) + ".js";
};